angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/proposals/proposals.html',
    '<update-title title="PEforHire.com"></update-title>\n' +
    '<!-- Proposals -->\n' +
    '<section class="content dashboard" ng-init="initProposals()">\n' +
    '    <div class="container">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12">\n' +
    '                <ul class="hidden-xs list-inline pull-right mt60">\n' +
    '                    <li class="form-group text-muted">\n' +
    '                        Display:\n' +
    '                    </li>\n' +
    '                    <li class="form-group" ng-repeat="value in paging.values">\n' +
    '                        <input id="list-{{value}}" class="form-control" name="pageMode" ng-model="paging.mode"\n' +
    '                            ng-value="value" type="radio">\n' +
    '                        <label for="list-{{value}}">\n' +
    '                            <span></span>{{paging.display[$index]}}\n' +
    '                        </label>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '                <h2>My Projects</h2>\n' +
    '                <!-- Start -->\n' +
    '                <table class="table table-striped">\n' +
    '                    <thead>\n' +
    '                        <tr>\n' +
    '                            <th class="hidden-xs status-column proposals-status-column">\n' +
    '                                <a href="">Status</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="">Posted</a>\n' +
    '                            </th>\n' +
    '                            <th class="hidden-xs eng-type-column">\n' +
    '                                <a href="">Engineer Type</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="">Project Title</a>\n' +
    '                            </th>\n' +
    '                            <th class="hidden-xs">\n' +
    '                                <a href="">State</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="">Questions</a>\n' +
    '                            </th>\n' +
    '                            <th>\n' +
    '                                <a href="">Messages</a>\n' +
    '                            </th>\n' +
    '                            <th class="hidden-xs">\n' +
    '                                <a href="">View</a>\n' +
    '                            </th>\n' +
    '                            <th class="hidden-xs proposalsView_actionsColumn">\n' +
    '                                <a href="">Actions</a>\n' +
    '                            </th>\n' +
    '                        </tr>\n' +
    '                    </thead>\n' +
    '                    <tbody>\n' +
    '                        <tr ng-repeat="proposal in proposals">\n' +
    '                            <td class="hidden-xs">\n' +
    '                                <i class="fa fa-circle" ng-style="{\'color\':proposal.status.color}"></i>\n' +
    '                                {{proposal.status.label}}\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                                {{proposal.CreatedDate|standardMonthDayYear}}\n' +
    '                            </td>\n' +
    '                            <td class="hidden-xs">\n' +
    '                                {{proposal.license.Label}}\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                                <a class="title"\n' +
    '                                    ui-sref="project({uid: proposal.Project.UID})">{{proposal.Project.Title | characters:40}}</a>\n' +
    '                            </td>\n' +
    '                            <td class="hidden-xs text-center">{{proposal.Project.StateLicense}}</td>\n' +
    '                            <td>\n' +
    '                                <div\n' +
    '                                    ng-class="{\'unread-notification\': proposal.QuestionCount>0 && proposal.QuestionCount > proposal.QuestionRead}">\n' +
    '                                    {{proposal.QuestionCount}}</div>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                                <div ui-sref="project({uid: proposal.Project.UID})"\n' +
    '                                    ng-class="{\'unread-notification\': proposal.ProfUnreadMessages}">\n' +
    '                                    {{proposal.MessagesReceived}}</div>\n' +
    '                            </td>\n' +
    '                            <td>\n' +
    '                                <a ui-sref="project({uid: proposal.Project.UID, projectTitle: generateSeoUrlForProposal(proposal)})"\n' +
    '                                    class="btn btn-primary btn-xs">View</a>\n' +
    '                            </td>\n' +
    '                            <td class="proposalsView_actionsColumn">\n' +
    '                                <a ng-if="showStatusAction(proposal.Status)"\n' +
    '                                    ui-sref="proposals({uid: proposal.Project.UID})"\n' +
    '                                    class="btn btn-primary btn-xs">{{getStatusAction(proposal.Status)}}</a>\n' +
    '                            </td>\n' +
    '                        </tr>\n' +
    '                    </tbody>\n' +
    '                </table>\n' +
    '                <!-- Pagination -->\n' +
    '                <div class="text-left" ng-show="paging.mode != paging.values[paging.values.length-1]">\n' +
    '                    <div paging page="paging.current" ng-model="projectsAll" page-size="paging.mode"\n' +
    '                        total="paging.total" paging-action="goToPage(page)" prev="goToPage(paging.current-1)"\n' +
    '                        next="goToPage(paging.current+1)"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-send-invoice.html">\n' +
    '    <form name="form.invoiceForm" novalidate autocomplete="off" ng-submit="submitInvoice()">\n' +
    '        <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '            <h4 class="modal-title">Send Invoice</h4>\n' +
    '        </div>\n' +
    '        <div class="modal-body-send-invoice">\n' +
    '            <div class="form-group send-invoice-main-info">\n' +
    '                <div class="send-invoice-total-info">\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label for="inputEmail3" class="send-invoice-normal-text" style="width: 30%">Subtotal*</label>\n' +
    '                        <div class="input-group send-invoice-form-control">\n' +
    '                            <div class="input-group-addon">$</div>\n' +
    '                            <input required type="number" ng-model="invoiceSubtotal" name="invoiceSubtotal" ng-change="onSubtotalChange()" class="form-control send-invoice-value" id="exampleInputAmount" step="0.01" min="0" value=0 ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 }}" >\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="!calculatingBill && invalidTotalMessage.length === 0" class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Transaction Fees**</label>\n' +
    '                        <label class="send-invoice-value" style="margin-right: 28px">+ {{escrowFee | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="!calculatingBill && invalidTotalMessage.length === 0" class="send-invoice-separatorline"></div>\n' +
    '                    <div ng-if="!calculatingBill && invalidTotalMessage.length === 0" class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Billed to Client</label>\n' +
    '                        <label class="send-invoice-value" style="margin-right: 28px">{{escrowTotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                     <div ng-if="!calculatingBill && invalidTotalMessage.length === 0" class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text-bold">You Receive</label>\n' +
    '                        <label class="send-invoice-value send-invoice-value-total">{{invoiceSubtotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="calculatingBill" class="send-invoice-subtotal-info">\n' +
    '                        <div style="margin: auto" class="fa fa-refresh fa-spin"></div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="invalidTotalMessage.length" class="send-invoice-message-wrapper" style="width: fit-content">\n' +
    '                        <label class="send-invoice-invalid-error">{{invalidTotalMessage}}</label>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="send-invoice-message-wrapper" ng-repeat="message in sendInvoiceMessageTop">\n' +
    '                    <label class="send-invoice-message">{{message}}</label>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <textarea ng-model="invoiceText" name="invoiceText" class="form-control"\n' +
    '            rows="4" placeholder="{{sendInvoicePlaceholder}}" ng-change="updateCharactersLeft()" maxlength="2000"></textarea>\n' +
    '            <div class="help-block" ng-class="{ \'errors\': form.invoiceForm.invoiceText.$touched && (form.invoiceForm.invoiceText.$invalid||invoiceText.length>maxInvoiceLength) }"\n' +
    '            ng-messages="form.invoiceForm.invoiceText.$error" ng-if="form.invoiceForm.invoiceText.$touched">\n' +
    '                <p ng-message="required">This field is required</p>\n' +
    '                <p ng-if="invoiceText.length>maxInvoiceLength">This field is too long.</p>\n' +
    '            </div>\n' +
    '            <div>\n' +
    '                <div class="row mt10">\n' +
    '                    <div ng-if="false" class="col-sm-4 col-md-3 mt5">\n' +
    '                        <span class="btn btn-primary btn-file">\n' +
    '                            <i class="fa fa-paperclip fa-lg"></i>\n' +
    '                            &nbsp;Attach File\n' +
    '                            <input type="file" name="file" ngf-select ngf-keep="\'distinct\'" ngf-max-files="{{maxAttachmentFiles}}"\n' +
    '                                multiple ng-model="files" ngf-max-size="20MB" ngf-validate="{size: {max: \'20MB\'}}"\n' +
    '                                class="btn btn-default" ngf-pattern="{{acceptedFileFormats}}" ng-disabled="isUploading">\n' +
    '                        </span>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-8 col-mb-7">\n' +
    '                        <!-- Hide on opening -->\n' +
    '                        <div id="file-attached" class="" ng-repeat="file in files track by file.name">\n' +
    '                            <small style="word-wrap: break-word;">{{file.name}}</small>\n' +
    '                            <a href="javascript:;" class="trash" ng-click="removeFile(file)"></a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                    <div class="help-block" ng-class="{ \'errors\': form.invoiceForm.file.$invalid }" ng-messages="form.invoiceForm.file.$error">\n' +
    '                        <div ng-message="maxSize">\n' +
    '                            <p>File is too large, it must be smaller than 20 Mb</p>\n' +
    '                        </div>\n' +
    '                        <div ng-message="pattern">\n' +
    '                            <p>File format must be {{acceptedFileFormats}}</p>\n' +
    '                        </div>\n' +
    '                        <div ng-message="maxFiles">\n' +
    '                            <p>You can attach up to {{maxAttachmentFiles}} files</p>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <div class="form-group">\n' +
    '                <div class="col-md-12 text-left" ng-repeat="message in sendInvoiceMessageBottom">\n' +
    '                    <p>{{message}}</p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '                <div class="col-md-12">\n' +
    '                    <button type="button" ng-click="$close()" class="btn btn-default">Cancel</button>\n' +
    '                    <button type="submit" ng-disabled="form.invoiceForm.$invalid || invoiceText.length>maxInvoiceLength || invalidTotalMessage.length || invoiceText.length==0" class="btn btn-primary">\n' +
    '                           <span ng-show="!isUploading || files.length==0">Continue</span>\n' +
    '                    </button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-send-revised-invoice.html">\n' +
    '    <form name="form.invoiceForm" novalidate autocomplete="off" ng-submit="submitInvoice()">\n' +
    '        <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '            <h4 class="modal-title">Send Revised Invoice</h4>\n' +
    '        </div>\n' +
    '        <div class="modal-body-send-invoice">\n' +
    '            <div class="form-group send-invoice-main-info">\n' +
    '                <div class="send-invoice-total-info">\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label for="inputEmail3" class="send-invoice-normal-text" style="width: 30%">Subtotal*</label>\n' +
    '                        <div class="input-group send-invoice-form-control">\n' +
    '                            <div class="input-group-addon">$</div>\n' +
    '                            <input required type="number" ng-model="invoiceSubtotal" name="invoiceSubtotal" ng-change="onSubtotalChange()" class="form-control send-invoice-value" id="exampleInputAmount" step="0.01" min="0" value=0 ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 1000, \'blur\': 0 }}" >\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="!calculatingBill && invalidTotalMessage.length === 0" class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Transaction Fees**</label>\n' +
    '                        <label class="send-invoice-value" style="margin-right: 28px">+ {{escrowFee | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="!calculatingBill && invalidTotalMessage.length === 0" class="send-invoice-separatorline"></div>\n' +
    '                    <div ng-if="!calculatingBill && invalidTotalMessage.length === 0" class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Billed to Client</label>\n' +
    '                        <label class="send-invoice-value" style="margin-right: 28px">{{escrowTotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                     <div ng-if="!calculatingBill && invalidTotalMessage.length === 0" class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text-bold">You Receive</label>\n' +
    '                        <label class="send-invoice-value send-invoice-value-total">{{invoiceSubtotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="calculatingBill" class="send-invoice-subtotal-info">\n' +
    '                        <div style="margin: auto" class="fa fa-refresh fa-spin"></div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="invalidTotalMessage.length" class="send-invoice-message-wrapper" style="width: fit-content">\n' +
    '                        <label class="send-invoice-invalid-error">{{invalidTotalMessage}}</label>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="send-invoice-message-wrapper" ng-repeat="message in sendRevisedInvoiceMessageTop">\n' +
    '                    <label class="send-invoice-message">{{message}}</label>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <textarea ng-model="invoiceText" name="invoiceText" class="form-control"\n' +
    '            rows="4" placeholder="{{sendRevisedInvoicePlaceholder}}" ng-change="updateCharactersLeft()" maxlength="2000"></textarea>\n' +
    '            <div class="help-block" ng-class="{ \'errors\': form.invoiceForm.invoiceText.$touched && (form.invoiceForm.invoiceText.$invalid||invoiceText.length>maxInvoiceLength) }"\n' +
    '            ng-messages="form.invoiceForm.invoiceText.$error" ng-if="form.invoiceForm.invoiceText.$touched">\n' +
    '                <p ng-message="required">This field is required</p>\n' +
    '                <p ng-if="invoiceText.length>maxInvoiceLength">This field is too long.</p>\n' +
    '            </div>\n' +
    '            <div>\n' +
    '                <div class="row mt10">\n' +
    '                    <div ng-if="false" class="col-sm-4 col-md-3 mt5">\n' +
    '                        <span class="btn btn-primary btn-file">\n' +
    '                            <i class="fa fa-paperclip fa-lg"></i>\n' +
    '                            &nbsp;Attach File\n' +
    '                            <input type="file" name="file" ngf-select ngf-keep="\'distinct\'" ngf-max-files="{{maxAttachmentFiles}}"\n' +
    '                                multiple ng-model="files" ngf-max-size="20MB" ngf-validate="{size: {max: \'20MB\'}}"\n' +
    '                                class="btn btn-default" ngf-pattern="{{acceptedFileFormats}}" ng-disabled="isUploading">\n' +
    '                        </span>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-8 col-mb-7">\n' +
    '                        <!-- Hide on opening -->\n' +
    '                        <div id="file-attached" class="" ng-repeat="file in files track by file.name">\n' +
    '                            <small style="word-wrap: break-word;">{{file.name}}</small>\n' +
    '                            <a href="javascript:;" class="trash" ng-click="removeFile(file)"></a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="row">\n' +
    '                    <div class="help-block" ng-class="{ \'errors\': form.invoiceForm.file.$invalid }" ng-messages="form.invoiceForm.file.$error">\n' +
    '                        <div ng-message="maxSize">\n' +
    '                            <p>File is too large, it must be smaller than 20 Mb</p>\n' +
    '                        </div>\n' +
    '                        <div ng-message="pattern">\n' +
    '                            <p>File format must be {{acceptedFileFormats}}</p>\n' +
    '                        </div>\n' +
    '                        <div ng-message="maxFiles">\n' +
    '                            <p>You can attach up to {{maxAttachmentFiles}} files</p>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <div class="form-group">\n' +
    '                <div class="col-md-12 text-left" ng-repeat="message in sendRevisedInvoiceMessageBottom">\n' +
    '                    <p>{{message}}</p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '                <div class="col-md-12">\n' +
    '                    <button type="button" ng-click="$close()" class="btn btn-default">Cancel</button>\n' +
    '                    <button type="submit" ng-disabled="form.invoiceForm.$invalid || invoiceText.length>maxInvoiceLength || invalidTotalMessage.length || invoiceText.length==0" class="btn btn-primary">\n' +
    '                           <span ng-show="!isUploading || files.length==0">Continue</span>\n' +
    '                    </button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-send-invoice-confirmation.html">\n' +
    '    <form name="form.invoiceForm" novalidate autocomplete="off">\n' +
    '        <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '            <h4 class="modal-title">Confirm Invoice</h4>\n' +
    '        </div>        \n' +
    '        <div class="send-invoice-body">\n' +
    '                <div class="send-invoice-confirmation-total-info">\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Subtotal*</label>\n' +
    '                        <label class="send-invoice-value">{{invoiceSubtotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Transaction Fees**</label>\n' +
    '                        <label class="send-invoice-value">+ {{escrowFee | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div class="send-invoice-separatorline"></div>\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Billed to Client</label>\n' +
    '                        <label class="send-invoice-value">{{escrowTotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text" style="font-weight: bold">You Receive</label>\n' +
    '                        <label class="send-invoice-value" style="font-weight: bold">{{invoiceSubtotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="invoiceText.length" class="send-invoice-confirmation-note">\n' +
    '                        <label class="send-invoice-confirmation-note-text">Note: {{invoiceText}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="files.length" class="send-invoice-attachment-wrapper">\n' +
    '                        <label class="send-invoice-attachment-text">Attachments:</label>\n' +
    '                        <div class="send-invoice-attachments-list">\n' +
    '                            <div ng-repeat="file in files track by file.name" >\n' +
    '                                <label class="send-invoice-confirmation-note-text">{{file.name}}</label>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <div class="form-group">\n' +
    '                <div class="col-md-12 text-left" ng-repeat="message in sendInvoiceMessageConfirmation">\n' +
    '                    <p>{{message}}</p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '                <div class="col-md-12">\n' +
    '                    <button type="button" ng-click="$close()" class="btn btn-default">Back</button>\n' +
    '                    <button type="button" ng-click="submitInvoice()" ng-disabled="form.invoiceForm.$invalid || invoiceText.length>maxInvoiceLength || isUploading" class="btn btn-primary">\n' +
    '                        <span ng-show="isUploading && files.length">{{uploadPercentage}}% Sent</span>\n' +
    '                        <span ng-show="!isUploading || files.length==0">Send</span>\n' +
    '                    </button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-send-revised-invoice-confirmation.html">\n' +
    '    <form name="form.invoiceForm" novalidate autocomplete="off">\n' +
    '        <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '            <h4 class="modal-title">Confirm Revised Invoice</h4>\n' +
    '        </div>        \n' +
    '        <div class="send-invoice-body">\n' +
    '                <div class="send-invoice-confirmation-total-info">\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Subtotal*</label>\n' +
    '                        <label class="send-invoice-value">{{invoiceSubtotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Transaction Fees**</label>\n' +
    '                        <label class="send-invoice-value">+ {{escrowFee | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div class="send-invoice-separatorline"></div>\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Billed to Client</label>\n' +
    '                        <label class="send-invoice-value">{{escrowTotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text" style="font-weight: bold">You Receive</label>\n' +
    '                        <label class="send-invoice-value" style="font-weight: bold">{{invoiceSubtotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="invoiceText.length" class="send-invoice-confirmation-note">\n' +
    '                        <label class="send-invoice-confirmation-note-text">Note: {{invoiceText}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="files.length" class="send-invoice-attachment-wrapper">\n' +
    '                        <label class="send-invoice-attachment-text">Attachments:</label>\n' +
    '                        <div class="send-invoice-attachments-list">\n' +
    '                            <div ng-repeat="file in files track by file.name" >\n' +
    '                                <label class="send-invoice-confirmation-note-text">{{file.name}}</label>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <div class="form-group">\n' +
    '                <div class="col-md-12 text-left" ng-repeat="message in sendInvoiceMessageConfirmation">\n' +
    '                    <p>{{message}}</p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '                <div class="col-md-12">\n' +
    '                    <button type="button" ng-click="$close()" class="btn btn-default">Back</button>\n' +
    '                    <button type="button" ng-click="submitInvoice()" ng-disabled="form.invoiceForm.$invalid || invoiceText.length>maxInvoiceLength || isUploading" class="btn btn-primary">\n' +
    '                        <span ng-show="isUploading && files.length">{{uploadPercentage}}% Sent</span>\n' +
    '                        <span ng-show="!isUploading || files.length==0">Send</span>\n' +
    '                    </button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-send-invoice-ok.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Invoice Sent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in sentInvoiceMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-send-revised-invoice-ok.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Revised Invoice Sent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in sentRevisedInvoiceMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-request-release-of-funds.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Send Request for Release of Funds</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body row">\n' +
    '        <div class="col-xs-1">\n' +
    '            <input type="checkbox" ng-model="confirmed" id="certify-work-completion-id"/>\n' +
    '            <label for="certify-work-completion-id"><span></span></label>\n' +
    '        </div>\n' +
    '        <div ng-repeat="message in requestReleaseOfFundsMessage">\n' +
    '            <p class="col-xs-11">{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button ng-disabled="!confirmed" type="button" ng-click="requestReleaseOfFunds()" class="btn btn-primary">Send</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-request-release-of-funds-sent.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Request Sent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in requestReleaseOfFundsSentMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-re-request-release-of-funds.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Resend Request for Release of Funds</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body row">\n' +
    '        <div class="col-xs-1">\n' +
    '            <input type="checkbox" ng-model="confirmed" id="certify-work-completion-id"/>\n' +
    '            <label for="certify-work-completion-id"><span></span></label>\n' +
    '        </div>\n' +
    '        <div ng-repeat="message in requestReleaseOfFundsMessage">\n' +
    '            <p class="col-xs-11">{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button ng-disabled="!confirmed" type="button" ng-click="requestReleaseOfFunds()" class="btn btn-primary">Resend</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-re-request-release-of-funds-sent.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Request Resent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in requestReleaseOfFundsSentMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-resend-invoice.html">\n' +
    '    <form name="form.invoiceForm" novalidate autocomplete="off" ng-submit="submitInvoice()">\n' +
    '        <div class="modal-header">\n' +
    '            <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '                <i class="fa fa-times"></i>\n' +
    '            </a>\n' +
    '            <h4 class="modal-title">Resend Invoice</h4>\n' +
    '        </div>\n' +
    '        <div class="modal-body-send-invoice">\n' +
    '            <div class="form-group send-invoice-main-info">\n' +
    '                <div class="send-invoice-total-info">\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label for="inputEmail3" class="send-invoice-normal-text" style="width: 30%">Subtotal*</label>\n' +
    '                        <div class="input-group send-invoice-form-control">\n' +
    '                            <div class="input-group-addon">$</div>\n' +
    '                            <input disabled type="number" ng-model="invoiceSubtotal" name="invoiceSubtotal" class="form-control send-invoice-value" id="exampleInputAmount">\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Transaction Fees**</label>\n' +
    '                        <label class="send-invoice-value" style="margin-right: 28px">+ {{escrowFee | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div class="send-invoice-separatorline"></div>\n' +
    '                    <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text">Billed to Client</label>\n' +
    '                        <label class="send-invoice-value" style="margin-right: 28px">{{escrowTotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                     <div class="send-invoice-subtotal-info">\n' +
    '                        <label class="send-invoice-normal-text-bold">You Receive</label>\n' +
    '                        <label class="send-invoice-value send-invoice-value-total">{{invoiceSubtotal | currency:"":2}}</label>\n' +
    '                    </div>\n' +
    '                    <div ng-if="calculatingBill" class="send-invoice-subtotal-info">\n' +
    '                        <div style="margin: auto" class="fa fa-refresh fa-spin"></div>\n' +
    '                    </div>\n' +
    '                    <div ng-if="invalidTotalMessage.length" class="send-invoice-message-wrapper" style="width: fit-content">\n' +
    '                        <label class="send-invoice-invalid-error">{{invalidTotalMessage}}</label>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="send-invoice-message-wrapper" ng-repeat="message in resendInvoiceMessageTop">\n' +
    '                    <label class="send-invoice-message">{{message}}</label>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <textarea disabled ng-model="invoiceText" name="invoiceText" class="form-control"\n' +
    '            rows="4" placeholder="{{resendInvoicePlaceholder}}" ng-change="updateCharactersLeft()" maxlength="2000"></textarea>\n' +
    '            <div>\n' +
    '                <div class="row mt10">\n' +
    '                    <div class="col-sm-4 col-md-3 mt5">\n' +
    '                        <span>\n' +
    '                            Attachments:\n' +
    '                        </span>\n' +
    '                    </div>\n' +
    '                    <div class="col-sm-8 col-mb-7">\n' +
    '                        <!-- Hide on opening -->\n' +
    '                        <div id="file-attached" class="" ng-repeat="file in files track by file.name">\n' +
    '                            <a href="{{file.url}}" target="_blank" style="margin-left: 20px">{{file.name}}</a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="modal-footer">\n' +
    '            <div class="form-group">\n' +
    '                <div class="col-md-12 text-left" ng-repeat="message in resendInvoiceMessageBottom">\n' +
    '                    <p>{{message}}</p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="row">\n' +
    '                <div class="col-md-12">\n' +
    '                    <button type="button" ng-click="$close()" class="btn btn-default">Cancel</button>\n' +
    '                    <button type="submit" class="btn btn-primary">Resend</button>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-resend-invoice-ok.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" data-dismiss="modal" ng-click="$close();" aria-label="Close">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Invoice Resent!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <div ng-repeat="message in sentInvoiceMessage">\n' +
    '            <p>{{message}}</p>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <div class="col-md-12">\n' +
    '            <button type="button" ng-click="$close()" class="btn btn-default">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '');
}]);
